// https://redux-saga.js.org/
import { takeLatest, call, put, delay } from "redux-saga/effects";
import * as actionCreators from "./action-creators";
import { LOAD_PRODUCTS_DATA, LOAD_ITEM_COMMENTS_DATA, LOAD_CATEGORY_COMMENTS_DATA } from "./actions";
import { ProductsStatus, ItemCommentsStatus, CategoryCommentsStatus } from "./constants";
import { get, findIndex } from "lodash";
import api from "../../../utilities/api";
import Cookies from "universal-cookie";

export function* rootSaga() {
  yield takeLatest(LOAD_PRODUCTS_DATA, loadProducts);
  yield takeLatest(LOAD_ITEM_COMMENTS_DATA, loadItemComments);
  yield takeLatest(LOAD_CATEGORY_COMMENTS_DATA, loadCategoryComments);
}

export function* loadProducts(data) {
  try {
    yield put(actionCreators.setProductsStatus(ProductsStatus.LOADING));
    // console.log("data", data);
    if (data) {
      const productId = get(data, "payload", "");
      const currentProductsData = get(data, "0", "");
      // console.log("productId", productId);
      // console.log("currentProductsData", currentProductsData);

      const cookies = new Cookies();
      const token = cookies.get("LoginToken"); // does this throw error when there is no loginToken? This will logout if there is no token. Handled in the private layout
      const headerParams = {
        Authorization: `Bearer ${token}`,
      };
      let productDataArray = [];
      // console.log("productId == StockOrders", productId == "StockOrders");

      if (productId == "StockOrders") {
        const response = yield call(
          api.get,
          `/api/item/stockorders`,
          {
            headers: headerParams,
          }
        );
        const index = findIndex(currentProductsData, { Code: "StockOrders" });
        if (index !== -1) {
          productDataArray = [...response.data];
          currentProductsData[index].InverseParentCodeNavigation =
            productDataArray;
          // console.log("currentProductsData", currentProductsData);
          yield put(actionCreators.setProductsData(currentProductsData));
          yield put(actionCreators.setProductsStatus(ProductsStatus.SUCCESS));
        }
      } else {
        const response = yield call(api.get, "/api/category", {
          headers: headerParams,
        });
        productDataArray = [...response.data];
        // console.log(response.data);
        // console.log(response.data);

        // productDataArray = filter(response.data, item => item.ParentCode == null && item.InverseParentCodeNavigation.length > 0);
        // const earpiecesType = find(response.data, item => item.Type == "Earpiece");
        // productDataArray.push(earpiecesType);
        // const accRgrChgType = find(response.data, item => item.Type == "AccRgrChg");
        // productDataArray.push(accRgrChgType);

        //console.log("productDataArray", productDataArray);

        yield put(actionCreators.setProductsData(productDataArray));
        yield put(actionCreators.setProductsStatus(ProductsStatus.SUCCESS));
      }
    }
  } catch (error) {
    yield put(actionCreators.setProductsStatus(ProductsStatus.ERROR));
  }
}

export function* loadItemComments() {
  try {
    yield put(actionCreators.setItemCommentsStatus(ItemCommentsStatus.LOADING));

    const cookies = new Cookies();
    const token = cookies.get("LoginToken");
    const headerParams = {
      Authorization: `Bearer ${token}`,
    };
    let response = {};
    //console.log(categoryId, productId);

    // Checks what family type the item is and call to respective API endpoint
    response = yield call(
      api.get,
      // `/api/earpiece/${productId.ModelCode}`,
      `/api/catalogueItemComment/`,
      { headers: headerParams }
    );
    // Saves order builder data
    // console.log("response.data.Payload", response.data.Payload);
    yield put(actionCreators.setItemCommentsData(response.data.Payload));
    yield put(actionCreators.setItemCommentsStatus(ItemCommentsStatus.SUCCESS));
  } catch (error) {
    yield put(actionCreators.setItemCommentsStatus(ItemCommentsStatus.ERROR));
  }
}

export function* loadCategoryComments() {
  // console.log("loadCategoryComments saga called");
  try {
    yield put(actionCreators.setCategoryCommentsStatus(CategoryCommentsStatus.LOADING));

    const cookies = new Cookies();
    const token = cookies.get("LoginToken");
    const headerParams = {
      Authorization: `Bearer ${token}`,
    };
    let response = {};
    //console.log(categoryId, productId);

    // Checks what family type the item is and call to respective API endpoint
    response = yield call(
      api.get,
      // `/api/earpiece/${productId.ModelCode}`,
      `/api/catalogueCategoryComment/`,
      { headers: headerParams }
    );
    // Saves order builder data
    // console.log("response.data.Payload", response.data.Payload);
    yield put(actionCreators.setCategoryCommentsData(response.data.Payload));
    yield put(actionCreators.setCategoryCommentsStatus(CategoryCommentsStatus.SUCCESS));
  } catch (error) {
    yield put(actionCreators.setCategoryCommentsStatus(CategoryCommentsStatus.ERROR));
  }
}
